import type { AnyVariables, Client, DocumentInput } from "@urql/next"
import { PREFETCH_CONTEXT } from "./client/exchange/request-policy"

export function prefetch<
  // biome-ignore lint/suspicious/noExplicitAny: TODO FIX -- its okay
  Data = any,
  Variables extends AnyVariables = AnyVariables,
>(client: Client, query: DocumentInput<Data, Variables>, variables: Variables) {
  void client.query(query, variables, PREFETCH_CONTEXT).toPromise()
}
